/** Format only recognizable NANP numbers. Other countries and unrecognized text stay intact. */
export function formatContactPhone(value: string): string {
  const extension = value.match(/\s*(?:ext\.?|x|#)\s*(\d+)\s*$/i);
  const main = extension ? value.slice(0, extension.index).trim() : value;
  if (!/^\+?[\d\s().-]*$/.test(main) || (main.trim().startsWith("+") && !main.trim().startsWith("+1"))) return value;
  const digits = main.replace(/\D/g, "");
  const country = main.trim().startsWith("+1") || (digits.length === 11 && digits.startsWith("1"));
  const local = country ? digits.slice(1) : digits;
  if (local.length < 4 || local.length > 10 || !/^[2-9]/.test(local) || (local.length >= 4 && !/[2-9]/.test(local[3]!)) || (extension && local.length !== 10)) return value;
  const formatted = `(${local.slice(0, 3)}) ${local.slice(3, 6)}${local.length > 6 ? "-" + local.slice(6) : ""}`;
  const result = `${country ? "+1 " : ""}${formatted}${extension ? " ext. " + extension[1] : ""}`;
  // Formatting must not turn an otherwise valid stored value into an over-limit one.
  return result.length <= 50 ? result : value;
}

export function normalizeContactPhone(value: string): string | null {
  const trimmed = value.trim();
  return trimmed ? formatContactPhone(trimmed) : null;
}

/** Preserve the logical digit position, including selections, when punctuation is inserted. */
export function phoneCaret(value: string, formatted: string, position: number): number {
  if (value === formatted || position === 0) return position;
  if (position === value.length) return formatted.length;
  const digits = value.slice(0, position).replace(/\D/g, "").length;
  if (!digits) return 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i++) if (/\d/.test(formatted[i]!) && ++seen === digits) return i + 1;
  return formatted.length;
}
